export const ADMIN_LOGIN_REQUEST = 'ADMIN_LOGIN_REQUEST';
export const ADMIN_LOGIN_SUCCESS = 'ADMIN_LOGIN_SUCCESS';
export const ADMIN_LOGIN_FAILURE = 'ADMIN_LOGIN_FAILURE';

export const CONTRACTOR_STATUS_EDIT_REQUEST = 'CONTRACTOR_STATUS_EDIT_REQUEST';
export const CONTRACTOR_STATUS_EDIT_SUCCESS = 'CONTRACTOR_STATUS_EDIT_SUCCESS';
export const CONTRACTOR_STATUS_EDIT_FAILURE = 'CONTRACTOR_STATUS_EDIT_FAILURE';
